var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfessoruBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.25 0H5C2.23858 0 -1.49012e-07 2.18261 -1.49012e-07 4.875V30.4688C-1.49012e-07 31.1418 0.559644 31.6875 1.25 31.6875H23.75C24.4404 31.6875 25 31.1418 25 30.4688C25 29.7957 24.4404 29.25 23.75 29.25H2.5C2.5 27.9038 3.61929 26.8125 5 26.8125H26.25C26.9404 26.8125 27.5 26.2668 27.5 25.5938V1.21875C27.5 0.545653 26.9404 0 26.25 0V0ZM25 24.375H5C4.1221 24.3738 3.25954 24.5993 2.5 25.0286V4.875C2.5 3.52881 3.61929 2.4375 5 2.4375H25V24.375Z",
    fill: "#00067E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessoruBlue);
export default __webpack_public_path__ + "static/media/professoru-blue.af2cd987aa8c1ccc76894a3a08f0eea6.svg";
export { ForwardRef as ReactComponent };